import React from 'react';
import { regex_solo_numeros } from '../index';
import { FormControlLabel, Checkbox, Typography } from "@material-ui/core";

export const ValidacionesCheckboxes = ({estadoOcultoOConsolidado,
                                        campo_check,
                                        handleChange,
                                        label_unchecked_autorizado,
                                        label_unchecked_no_autorizado,
                                        label_checked}) => {

    if(estadoOcultoOConsolidado && campo_check){
        return  <div className="flex items-center gap-1.5 py-2">
            <span className="text-sm font-semibold text-green-600 bg-green-50 px-2.5 py-1 rounded-md border border-green-200">
                ✓ {label_checked}
            </span>
            </div>
    }

    if (estadoOcultoOConsolidado && !campo_check) {
        return (
            <div className="flex items-center gap-1.5 py-2">
                <span className="text-sm font-semibold text-amber-700 bg-amber-50 px-2.5 py-1 rounded-md border border-amber-200 flex items-center gap-1.5 animate-pulse-subtle">
                    <span className="h-2 w-2 rounded-full bg-amber-500 inline-block"></span>
                    {label_unchecked_no_autorizado}
                </span>
            </div>
        );
    }   

    return <FormControlLabel
            control={
                <Checkbox 
                checked={campo_check}
                onChange={handleChange}
                color="primary"
                />
            }
            label={<span className="text-sm text-gray-600 font-medium">{label_unchecked_autorizado}</span>}
            />
};